<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { ArrowDownRightIcon, ArrowRightIcon, ArrowUpRightIcon } from '@heroicons/vue/16/solid'
import { computed } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  value: number
  class?: HTMLAttributes['class']
}>()

const slots = defineSlots<{
  default?: () => unknown
}>()

const trends = {
  up: { icon: ArrowUpRightIcon, class: 'text-green-600', label: 'Up' },
  flat: { icon: ArrowRightIcon, class: 'text-gray-700', label: 'No change' },
  down: { icon: ArrowDownRightIcon, class: 'text-error', label: 'Down' },
}

const direction = computed(() => (props.value > 0 ? 'up' : props.value < 0 ? 'down' : 'flat'))
</script>

<template>
  <span
    data-slot="trend"
    :data-trend="direction"
    :class="
      cn(
        'inline-flex items-center gap-1 whitespace-nowrap font-display leading-none',
        trends[direction].class,
        props.class,
      )
    "
  >
    <slot />
    <span v-if="!slots.default" class="sr-only">{{ trends[direction].label }}</span>
    <component :is="trends[direction].icon" class="-my-[0.1em] size-[1.2em]! shrink-0" aria-hidden="true" />
  </span>
</template>
